<template>
  <div>
    <FetchingDataSpinner
      :loading="fetching"
      loading-title="جلب معلومات المنشور"
    />
    <template v-if="!fetching">
      <b-card>
        <template #default>
          <h3 class="text-center w-100">
            {{ $t('poster.post-page-title',{page:currentAccount.name}) }}
          </h3>
        </template>
      </b-card>
      <b-row>
        <b-col
          md="7"
          sm="12"
        >
          <b-card>
            <poster-form />
          </b-card>

        </b-col>
        <b-col
          md="5"
          sm="12"
        >
          <b-card>
            <poster-preview />
          </b-card>

        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import PosterPreview from '@/views/owner-instagram/poster/components/PosterPreview'
import PosterForm from '@/views/owner-instagram/poster/components/PosterForm'
import FetchingDataSpinner from '@/@bya3/components/utils/FetchingDataSpinner'
import InstagramPosterApi from '@/api/instagram/poster'

export default {
  name: 'AddPostPage',
  components: {
    FetchingDataSpinner,
    PosterForm,
    PosterPreview,
    BCard,
    BRow,
    BCol,
  },
  data() {
    return {
      fetching: false,
    }
  },
  computed: {
    ...mapGetters({
      currentAccount: 'instagram/currentAccount',
    }),
    idEdit() {
      return !!this.$route.params.id
    },
  },
  async  mounted() {
    if (this.idEdit) {
      await this.fetchPost()
    }
  },
  methods: {
    async fetchPost() {
      this.fetching = true
      await InstagramPosterApi.fetchPost(this.currentAccount.id, this.$route.params.id).then(res => {
        this.$store.commit('instagram/SET_POST_FORM', {
          caption: res.post?.full_caption,
          files: res.post?.files_ids ?? [],
          reply_message: res.post?.reply_message?.text ?? '',
          schedule_type: (res.post?.is_posted ?? false) ? 'now' : 'later',
          schedule_time: res.post?.post_at ?? '',
          template_id: res.post?.reply?.id,
        })
      }).finally(() => { this.fetching = false })
      this.$store.commit('instagram/SET_FROM_EDIT')
    },
  },
}
</script>
